import { createContext, useContext, useRef } from 'react';

/**
 * Shares the billing form's imperative API (validate + read values) with
 * OrderSummary, which only needs it at "Proceed To Payment" click time.
 *
 * This is deliberately a ref, not state and not Redux: the previous version
 * pushed every keystroke through `dispatch(setBillingData(watch()))`, and
 * because `watch()` returns a fresh object each render that effect re-fired on
 * every render — a render -> dispatch -> render loop that made typing crawl.
 * A ref carries the same data with zero re-renders.
 */
const CheckoutFormContext = createContext(null);

const NOOP_API = {
	trigger: async () => false,
	getValues: () => ({}),
};

export function CheckoutFormProvider({ children }) {
	const formApi = useRef(NOOP_API);

	return <CheckoutFormContext.Provider value={formApi}>{children}</CheckoutFormContext.Provider>;
}

export function useCheckoutFormApi() {
	const ctx = useContext(CheckoutFormContext);

	if (!ctx) {
		throw new Error('useCheckoutFormApi must be used inside <CheckoutFormProvider>');
	}

	return ctx;
}
